/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CaptureSettings,
    CaptureSettingsFromJSON,
    CaptureSettingsFromJSONTyped,
    CaptureSettingsToJSON,
} from './CaptureSettings';

/**
 * 
 * @export
 * @interface SceneResponse
 */
export interface SceneResponse {
    /**
     * 
     * @type {number}
     * @memberof SceneResponse
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof SceneResponse
     */
    organizationId: number;
    /**
     * 
     * @type {string}
     * @memberof SceneResponse
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof SceneResponse
     */
    note?: string;
    /**
     * 
     * @type {number}
     * @memberof SceneResponse
     */
    deviceId?: number;
    /**
     * List of identifiers of locatities the scene is assigned to, in ascending order
     * @type {Array<number>}
     * @memberof SceneResponse
     */
    localityIds: Array<number>;
    /**
     * 
     * @type {CaptureSettings}
     * @memberof SceneResponse
     */
    captureSettings: CaptureSettings;
}

export function SceneResponseFromJSON(json: any): SceneResponse {
    return SceneResponseFromJSONTyped(json, false);
}

export function SceneResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SceneResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': json['organization_id'],
        'label': json['label'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'deviceId': !exists(json, 'device_id') ? undefined : json['device_id'],
        'localityIds': json['locality_ids'],
        'captureSettings': CaptureSettingsFromJSON(json['capture_settings']),
    };
}

export function SceneResponseToJSON(value?: SceneResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'organization_id': value.organizationId,
        'label': value.label,
        'note': value.note,
        'device_id': value.deviceId,
        'locality_ids': value.localityIds,
        'capture_settings': CaptureSettingsToJSON(value.captureSettings),
    };
}

